import { ChangeDetectionStrategy, Component, HostListener, inject, input } from '@angular/core';
import { Router } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';
import { WorkflowOrigin } from '@warema/shared/models';
import { SharedSvgModule } from '@warema/shared/svg';

@Component({
    selector: 'warema-back-button',
    imports: [TranslatePipe, SharedSvgModule],
    templateUrl: './back-button.component.html',
    styleUrls: ['./back-button.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BackButtonComponent {
    private readonly _router = inject(Router);

    public readonly workflowOrigin = input.required<WorkflowOrigin>();
    public readonly projectName = input('');

    public readonly workflowOriginEnum = WorkflowOrigin;

    @HostListener('click')
    @HostListener('keydown', ['$event'])
    public onHostClick(event?: KeyboardEvent): void {
        if (event && event.key !== 'Enter' && event.key !== ' ') {
            return;
        }

        if (this.workflowOrigin() === WorkflowOrigin.WaremaPlusProjects) {
            void this._router.navigateByUrl('projects');
        } else {
            void this._router.navigateByUrl('appointments');
        }
    }
}
